export enum PaymentDirection {
  INFLOW = "INFLOW",
  OUTFLOW = "OUTFLOW",
}
